import * as React from "react"
import PropTypes from 'prop-types'
import Layout from "../components/layout"
import Banner from "../components/general/banner/banner"
import { Row, Col } from 'react-bootstrap';
import Categories from "../components/general/categories/categories"
import Breadcrumbs from "../components/general/breadcrumbs/breadcrumbs"
import Post from "../components/post/post";
import SEO from "../components/seo";

import { graphql } from 'gatsby'

class LatestPage extends React.Component {
  render() {
    let { data } = this.props



    const posts = data.allWpPost.nodes

    const categoryDetail = data.wpPost.postFields.categoriesDetails

    const categoryMeta = categoryDetail.filter(catdetail => catdetail.category.termTaxonomyId === 68)

    return (
      <Layout>
        <SEO title={categoryMeta[0] && categoryMeta[0].categoryMeta.metaTitle}
             description={categoryMeta[0] && categoryMeta[0].categoryMeta.metaDescription}
             ogimage={categoryMeta[0] && categoryMeta[0].categoryMeta.metaOgImage} />
        <div className="mb-5">

          <div className="w-100">
            {<Banner title={categoryMeta[0] && categoryMeta[0].categoryMeta.metaTitle}
                    bannerimg={categoryMeta[0] && categoryMeta[0].heroImage.localFile} />}
          </div>
          <div className={'saContainer'}>
            <Row>
              <Col lg="12">
                <Breadcrumbs pageTitle="Latest" />
              </Col>
              <Col lg="9" className="pt-3">
                {posts.map(post => (
                  <Post post={post} />
                ))}
              </Col>
              <Col lg="3" className="pt-3 sidebar">
                <Categories />
              </Col>
            </Row>
          </div>

        </div>
      </Layout>
    )
  }
}

LatestPage.propTypes = {
  data: PropTypes.shape({
    allWpPost: PropTypes.object
  })
}
  
export default LatestPage
  
export const LatestPageQuery = graphql`
  query LatestPageQuery { 
    allWpPost(limit: 20, sort: {fields: date, order: DESC}, filter: {terms: {nodes: {elemMatch: {name: {nin: ["brands", "component", "featured", "Uncategorized", "influencers"]}}}}}) {
      nodes {
        link
        title
        date(formatString: "MMM DD, YYYY")
        slug
        terms {
          nodes {
            name
            link
            nodeType
            slug
            ... on WpCategory {
              ancestors {
                nodes {
                  slug
                }
              }
            }
          }
        }
        categories {
          nodes {
            wpParent {
              node {
                id
              }
            }
            slug
          }
        }
        author {
          node {
            slug
            lastName
            firstName
          }
        }
        postFields {
          defaultFields {
            featuredImage {
              sourceUrl
              localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 300
                        formats: [AUTO, WEBP]
                        quality: 100
                        placeholder: NONE
                        backgroundColor: "transparent"
                      )
                    } 
                  }
            }
            excerpt
          }
        }
      }
    }
    wpPost(databaseId: {eq: 3008}) {
      postFields {
        categoriesDetails {
          category {
            termTaxonomyId
          }
          heroImage {
            sourceUrl
            localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 1920
                        formats: [AUTO, WEBP]
                        quality: 100
                        placeholder: NONE
                        backgroundColor: "transparent"
                      )
                    } 
                  }
          }
          mobileHeroImage {
            sourceUrl
            localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 300
                        formats: [AUTO, WEBP]
                        quality: 100
                        placeholder: NONE
                        backgroundColor: "transparent"
                      )
                    } 
                  }
          }
          categoryMeta {
            metaTitle
            metaDescription
            metaOgImage {
              sourceUrl
              localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 300
                        formats: [AUTO, WEBP]
                        quality: 100
                        placeholder: NONE
                        backgroundColor: "transparent"
                      )
                    } 
                  }
            }
          }
        }
      }
    }
    wpPage(databaseId: {eq: 1557}) {
      metaMain {
        title
        description
        ogimage {
          sourceUrl
          localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 300
                        formats: [AUTO, WEBP]
                        quality: 100
                        placeholder: NONE
                        backgroundColor: "transparent"
                      )
                    } 
                  }
        }
      }
    }
  }
`